import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const VideoSection = () => (
  <section id="video" className="video-section">
    <Title level={2}>Video Introduction</Title>
    <Paragraph type="secondary">
      I'm currently still in the process of making this video, I didn't mean to Rick Roll you, I'm sorry
    </Paragraph>
    <Card className="video-card" variant="borderless" styles={{ body: { padding: 0 } }}>
      <div className="video-wrapper">
        <iframe
          src="https://www.youtube.com/embed/dQw4w9WgXcQ"
          title="Video resume placeholder"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Card>
  </section>
);

export default VideoSection;
